// import { dateToString } from "@/src/common/date";
// import Image from "next/image";
// import Link from "next/link";
import React from 'react';
import GoodsCardSkeleton from './GoodsCardSkeleton';
// import GoodsReserveDdayBadge from './GoodsReserveDdayBadge';
import { Link } from 'react-router-dom';
import {
  apiUrl,
  bannerImgUrl,
  goodsImgUrl,
  groupImgUrl,
} from '../../common/urls';

const GoodsCard = ({ goods, options = {} }) => {
  const {
    /*     goodSerial,
    goodTitle,
    goodCode,
    price,
    dcPrice,
    dcRate,
    saleType,
    saleStart,
    saleEnd,
    saleActive,
    active,
    soldout, */
    img,
    /*     groupCode,
    groupName, */
    groupImg,
    /*     optionName, */
  } = goods;

  const { showOpenDay, number } = options;

  const isSale = goods.saleActive && goods.soldout === 'N';

  const _go = (url) => {
    window.open(url);
  };

  if (!goods) {
    return <GoodsCardSkeleton />;
  }

  return (
    goods && (
      <div className={`goods-card ${!isSale ? 'soldout' : ''}`}>
        <div
          className="top"
          style={{
            position: 'relative',
            borderRadius: '10px',
            overflow: 'hidden',
          }}
        >
          <div
            onClick={() =>
              _go(`https://shop.aniplustv.com/item/${goods.goodSerial}`)
            }
            style={{ cursor: 'pointer' }}
          >
            <img className="image" src={goodsImgUrl + img} />
            {/* <Image
              className="image"
              src={groupImg || img || '/images/thumb/NOIMAGE.png'}
              alt={goods.goodTitle}
              width={800}
              height={800}
              priority={number < 8 ? true : false}
            /> */}
            {!isSale && <span className="label">Sold out</span>}
            {/* {isSale && goods.isLast && goods.saleType === 'A' ? (
              <div
                style={{
                  position: 'absolute',
                  top: '12px',
                  left: '8px',
                }}
              >
                <GoodsReserveDdayBadge goods={goods} />
              </div>
            ) : null} */}
          </div>
        </div>
        <div
          className="content_a"
          onClick={() =>
            _go(`https://shop.aniplustv.com/item/${goods.goodSerial}`)
          }
          style={{ cursor: 'pointer' }}
        >
          {number && <span className={'cnt'}>{number}</span>}
          <span className="rcont">
            <div className="tit">{goods.groupName || goods.goodTitle}</div>
            {/* {goods.isLast && isSale ? (
                <span className="date">{`${dateToString(
                  new Date(goods.saleEnd)
                )} 마감`}</span>
              ) : null} */}
            {showOpenDay && (
              <span className="date">
                {(() => {
                  const open = new Date(goods.openday);

                  const year = open.getFullYear();
                  const month = open.getMonth() + 1;

                  return `${year}년 ${month}월 발매`;
                })()}
              </span>
            )}
            <span className="price">
              {goods.groupMinPrice > 0 && goods.groupMaxPrice > 0 ? (
                <>
                  <span
                    className="discount"
                    style={{ fontSize: '11px' }}
                  >{`${goods.groupMinPrice.toLocaleString()}원 ~ `}</span>
                  <span className="discount">{`${goods.groupMaxPrice.toLocaleString()}원`}</span>
                </>
              ) : (
                <>
                  {goods.dcPrice && (
                    <span className="discount">{`${goods.dcPrice.toLocaleString()}원`}</span>
                  )}
                  {goods.dcRate > 0 && (
                    <span className="won">{`${goods.price.toLocaleString()}원`}</span>
                  )}
                  {goods.dcRate > 0 && (
                    <span className="per">{`${goods.dcRate}%`}</span>
                  )}
                </>
              )}
            </span>
            <span className="tag" style={{ cursor: 'default' }}>
              {goods.saleType === 'A' && <span>예약</span>}
              {goods.saleType === 'B' && <span>입고</span>}
              {goods.goodsType === 'C' && <span>콜라보</span>}
              {goods.goodsType === 'O' && <span>오리지널</span>}
              {goods.groupCode && <span>옵션</span>}
              {isSale && goods.isNew && !goods.isLast ? (
                <span>신상품</span>
              ) : (
                <></>
              )}
              {isSale && goods.isLast ? <span>마감임박</span> : <></>}
              {!isSale && <span>판매종료</span>}
            </span>
          </span>
        </div>
      </div>
    )
  );
};

export default GoodsCard;
